import React from 'react';
import { Button } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { UIButtonVariant, UISize } from '../types';
import { copyWithNotification } from '@gik/core/utils/LinkUtils';
import SvgIcon from '../SvgIcon';
import { IButtonProps } from '../Button';

export interface ICopyButtonProps extends IButtonProps {
  text?: string;
  textToCopy: string;
  notificationText: string;
  variant?: UIButtonVariant;
  iconSize?: UISize;
  onClick?(): void;
}

const blockName = 'copy-button';

export default function ({
  text,
  textToCopy,
  notificationText,
  onClick,
  pill = true,
  size = 'sm',
  iconSize = 'sm',
  variant = 'default',
  ...otherProps
}: ICopyButtonProps) {
  const bem = bemBlock(blockName);

  return (
    <Button
      className={bem()}
      variant={variant}
      pill={pill}
      size={size}
      prepend={<SvgIcon size={iconSize} name={'Duplicate'} />}
      {...otherProps}
      onClick={() => {
        copyWithNotification(textToCopy, notificationText);
        onClick && onClick();
      }}
    >
      {text}
    </Button>
  );
}
